import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import EarningReleaseTable from "layouts/applications/EarningsRelease-Tables";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loadECDates } from "reducers/etc";

const FOMCMeetings = () => {
  const meetings = [
    { date: "27 - 28 Jan 2026" },
    { date: "17 - 18 Mar 2026 " },
    { date: "28 - 29 Apr 2026" },
    { date: "16 - 17 Jun 2026" },
    { date: "28 - 29 Jul 2026" },
    { date: "15 - 16 Sep 2026" },
    { date: "27 - 28 Oct 2026" },
    { date: "08 - 09 Dec 2026" },
  ];
  return (
    <div style={{ marginRight: "5px" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <SoftBox mb={3}>
          <SoftTypography variant="h5" al>
            FOMC Meetings
          </SoftTypography>
          <SoftTypography variant="body2">
            <strong>
              Previous FOMC Meeting Minutes:{" "}
              <a href="https://www.federalreserve.gov/monetarypolicy/fomcprojtabl20201216.htm" target="_blank">
                FOMC Statement, 15-16 Dec, 2025
              </a>
            </strong>
          </SoftTypography>
        </SoftBox>
      </div>
      <Grid container>
        <Grid item xs={6} md={6}>
          <SoftTypography variant="h5" textAlign="left">
            Event Name
          </SoftTypography>
        </Grid>
        <Grid item xs={6} md={6}>
          <SoftTypography variant="h5" textAlign="left">
            Dates
          </SoftTypography>
        </Grid>
      </Grid>
      {meetings.map((item, index) =>
        item.date ? (
          <Grid container>
            <Grid item xs={6} md={6}>
              <SoftTypography variant="body2" textAlign="left">
                2026 FOMC Meeting {index + 1}
              </SoftTypography>
            </Grid>
            <Grid item xs={6} md={6}>
              <SoftTypography variant="body2" textAlign="left">
                {item.date}
              </SoftTypography>
            </Grid>
          </Grid>
        ) : null
      )}
    </div>
  );
};

const UpcomingEarningCalls = () => {
  // const dispatch = useDispatch();
  // const ecdates = useSelector((state) => state.etc.ecDates);

  // useEffect(() => {
  //   dispatch(loadECDates());
  // }, []);

  const navigate = useNavigate();

  const viewAll = () => {
    navigate("/dashboard/research/earnings-call");
  };

  return (
    <>
      <SoftTypography variant="h4" mb={3}>
        Upcoming Earnings Call Dates
      </SoftTypography>
      {/* <Grid container spacing={2}>
        {ecdates.map((row, key) => {
          return (
            <Grid item xs={6} md={4}>
              <SoftTypography variant="body">
                <strong>{row["date"]}</strong>
              </SoftTypography>

              {row["stocks"].map((stock, key) => {
                return (
                  <SoftBox>
                    <SoftTypography variant="body2">{stock}</SoftTypography>
                  </SoftBox>
                );
              })}
            </Grid>
          );
        })}
      </Grid> */}
      <EarningReleaseTable previewOnly={true} />
      <SoftBox textAlign="center" mt={3}>
        <SoftButton variant="gradient" color="dark" onClick={viewAll}>
          View All
        </SoftButton>
      </SoftBox>
    </>
  );
};

const KeyYearEvents = () => {
  return (
    <Grid justifyContent="space-between" style={{ textAlign: "center", margin: "20px 0" }} container>
      <Grid className="dashboardCardsLg" p={2} style={{ backgroundColor: "white", borderRadius: "15px" }} item>
        <FOMCMeetings />
      </Grid>
      <Grid className="dashboardCardsSpecialSmOne economicCalendar" item>
        <UpcomingEarningCalls />
      </Grid>
    </Grid>
  );
};

export default KeyYearEvents;
